import type { FC } from "react";
import { useState } from "react";
import type { UseMutationResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { enterpriseCustomerUserAdminsQueryOptions } from "../api/enterpriseCustomer";
import type { RegistrationById } from "../api/registrations.types";
import { ResponsibleField } from "../pages/RegistrationsGridPage/RegistrationDrawer/RegistrationResponsible";

type SharedProcessingResponsibleProps = {
  sharedProcessing: RegistrationById;
  isReadOnly: boolean;
  setResponsibleMutation: UseMutationResult<unknown, Error, { id: string; userId: string }>;
};

export const SharedProcessingResponsible: FC<SharedProcessingResponsibleProps> = ({
  sharedProcessing,
  isReadOnly,
  setResponsibleMutation,
}) => {
  const [areSelectableUsersNeeded, setAreSelectableUsersNeeded] = useState(false);
  const adminsQuery = useQuery({
    ...enterpriseCustomerUserAdminsQueryOptions(),
    enabled: areSelectableUsersNeeded && !isReadOnly,
  });

  return (
    <ResponsibleField
      responsible={sharedProcessing.responsible}
      isReadOnly={isReadOnly}
      isSaving={setResponsibleMutation.isPending}
      hasError={setResponsibleMutation.isError}
      selectableUsers={adminsQuery.data}
      onSelectableUsersNeeded={() => setAreSelectableUsersNeeded(true)}
      onSelect={(userId, onError) => setResponsibleMutation.mutate({ id: sharedProcessing.id, userId }, { onError })}
    />
  );
};
